import MotivationsPost from "./MotivationsPost";

export default MotivationsPost;